import { detectCase } from "../../utils/detectCase";
import { ResultColumn } from "../SearchContents/SearchResults";
import { RowData } from "./BodyRow";
import {
    SearchResultsHeader,
    SearchResultsItem,
} from "../SearchContents/SearchContents";

export const composeTableHeaders = (
    columns: ResultColumn[]
): SearchResultsHeader[] => {
    return columns
        .filter(
            (columnDef) =>
                typeof columnDef.label !== "undefined" &&
                typeof columnDef.cellDisplay !== "undefined"
        )
        .map((columnDef) => {
            const { cellDisplay, columnKey, label, cellClassName } = columnDef;
            return {
                label,
                columnKey,
                cellDisplay,
                cellClassName,
            } as SearchResultsHeader;
        });
};

export const composeTableData = (
    headers: SearchResultsHeader[],
    items: SearchResultsItem[]
): RowData[] =>
    items.map((item) => {
        const { url } = item;
        const { determinationdateOfDecision, isExternalLink, isDfp } = item;
        return headers.length
            ? headers.map((header) => {
                  const { cellDisplay, columnKey, label } = header;
                  if (
                      detectCase(columnKey) !== "camelcase" &&
                      detectCase(columnKey) !== "lowercase"
                  ) {
                      throw new Error(
                          `columnKey value "${columnKey}" must use camelCase`
                      );
                  }
                  const cellProps = {
                      label: label,
                      header: columnKey,
                      data: item[columnKey] || "",
                      cellDisplay,
                      url: url ?? "",
                      determinationdateOfDecision:
                          determinationdateOfDecision ?? "",
                      isExternalLink: isExternalLink ?? "",
                      isDfp: isDfp ?? "",
                  };
                  return cellProps;
              })
            : [];
    });
